import React, { useEffect, useState, useRef } from 'react';
import { Controller } from 'react-hook-form';
import DropdownWithAnt from 'src/components/ui/DropdownWithAnt';
import Span from 'src/components/ui/Span';
import { useTranslation } from 'react-i18next';
import { getFormLabel, getFormPlaceholder, getFormInstructions, getFormOptionsWithEnglishValues } from 'src/helpers/multilingualHelper';
import { getTranslatedCountries } from 'src/constants/countryTranslations';
import logger from 'src/utils/logger';

const DropdownWithAntClientForm = ({ elementId, label, name, required, placeholder, options, errors, control, isLoading, config, onChange: onChangeCustom, value }) => {
    const [dropdownOptions, setDropdownOptions] = useState([]);
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language || 'en';

    const displayLabel = getFormLabel(label, currentLanguage);
    const displayPlaceholder = getFormPlaceholder(placeholder, currentLanguage);
    const displayInstructions = getFormInstructions(config?.instructions, currentLanguage);
    useEffect(() => {
        if (config.type === 'country') {
            const countryOptions = getTranslatedCountries(currentLanguage);
            logger.log("countryOptions", countryOptions)
            setDropdownOptions(countryOptions);
        } else {
            const dropdownOptions = getFormOptionsWithEnglishValues(options, currentLanguage);
            setDropdownOptions(dropdownOptions);
        }
    }, [label, name, options, currentLanguage]);

    return (
        <div className="relative inline-block w-full">
            <label htmlFor={elementId} className={`block ${config.hasInstructions ? '' : 'mb-2'} text-sm text-gray-700`}>
                {displayLabel}{required && '*'}
            </label>
            {
                config.hasInstructions && <label className="mb-2 text-xs text-gray-300">
                    {displayInstructions}
                </label>
            }
            <Controller
                name={elementId}
                control={control}
                rules={{ required: required }}
                render={({ field }) => {
                    if (!field.value && value) {
                        field.onChange(value);
                    }
                    return <DropdownWithAnt
                        {...field}
                        mode={config.isMultiple ? 'multiple' : undefined}
                        ref={field.ref}
                        options={dropdownOptions}
                        placeholder={displayPlaceholder}
                        status={errors[elementId] ? "error" : ""}
                        onChange={(e) => {
                            field.onChange(e);
                            onChangeCustom && onChangeCustom(elementId, null, e);
                        }}
                    />
                }}
            />
            {errors[elementId] && <Span className="text-FailRed400 text-xxs">{errors[elementId].message ? errors[elementId].message : t('form.thisFieldRequired')}</Span>}
        </div>
    );
};

export default DropdownWithAntClientForm;